import { HashRouter, Route } from "@solidjs/router";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <HashRouter>
      <Route path="/" component={Home} />
      <Route path="*" component={NotFound} />
    </HashRouter>
  );
}
